import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * Keeps delivery date block synced with selected variant.
 */
class ProductDeliveryDate extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateDeliveryDate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateDeliveryDate);
  }

  /**
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  updateDeliveryDate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newBlock = event.detail.data.html.querySelector(`product-delivery-date[data-block-id="${this.dataset.blockId}"]`);

    if (!newBlock) {
      this.style.display = 'none';
      return;
    }

    const newText = newBlock.querySelector('[ref="deliveryDateText"]')?.textContent?.trim() ?? '';

    if (!newText) {
      this.style.display = 'none';
      return;
    }

    const currentText = this.querySelector('[ref="deliveryDateText"]');
    if (currentText) currentText.textContent = newText;
    this.style.display = 'block';
  };
}

if (!customElements.get('product-delivery-date')) {
  customElements.define('product-delivery-date', ProductDeliveryDate);
}
